import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PortfolioPlaceholder from "@/components/site/PortfolioPlaceholder";
import { PORTFOLIO } from "@/constants/testIds";

const WORK = [
  {
    key: "school",
    title: "Redwood International School",
    industry: "School",
    variant: "school",
    subtitle: "SCHOOL WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-6",
  },
  {
    key: "college",
    title: "Northgate Institute of Technology",
    industry: "College",
    variant: "college",
    subtitle: "COLLEGE WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-6",
  },
  {
    key: "gym",
    title: "Ironforge Athletics",
    industry: "Gym",
    variant: "gym",
    subtitle: "GYM WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-4",
  },
  {
    key: "restaurant",
    title: "Solene Modern Kitchen",
    industry: "Restaurant",
    variant: "restaurant",
    subtitle: "RESTAURANT WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-4",
  },
  {
    key: "cafe",
    title: "Ember & Oak Café",
    industry: "Café",
    variant: "cafe",
    subtitle: "CAFÉ WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-4",
  },
  {
    key: "corporate",
    title: "Vertex Holdings Group",
    industry: "Corporate",
    variant: "corporate",
    subtitle: "CORPORATE WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-7",
  },
  {
    key: "healthcare",
    title: "Meridian Health Centre",
    industry: "Healthcare",
    variant: "healthcare",
    subtitle: "HEALTHCARE WEBSITE · IN DEVELOPMENT",
    span: "lg:col-span-5",
  },
];

const Portfolio = () => {
  return (
    <section
      id="portfolio"
      data-testid={PORTFOLIO.root}
      className="relative bg-[#08080a] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 flex flex-col items-start justify-between gap-6 lg:mb-20 lg:flex-row lg:items-end">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <div className="h-px w-8 bg-[var(--gold)]/60" />
              <span className="font-mono-label text-[var(--gold)]">
                04 · Our Work
              </span>
            </div>
            <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
              What&apos;s next<br />
              <span className="silver-gradient-text">starts here.</span>
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-zinc-400">
            Today&apos;s concepts. Tomorrow&apos;s success stories. Every
            completed project will replace these previews as we continue growing.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 lg:gap-6">
          {WORK.map((w, idx) => (
            <motion.a
              key={w.key}
              href="#contact"
              data-testid={`${PORTFOLIO.cardPrefix}-${w.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: (idx % 4) * 0.08,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className={`group relative col-span-12 block overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0e0e10] ${w.span}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden lg:aspect-[16/11]">
                <PortfolioPlaceholder variant={w.variant} subtitle={w.subtitle} />
              </div>
              <div className="flex items-start justify-between gap-4 p-6 lg:p-7">
                <div>
                  <div className="font-mono-label text-zinc-500">
                    {w.industry}
                  </div>
                  <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-white lg:text-2xl">
                    {w.title}
                  </h3>
                </div>
                <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/10 bg-white/[0.03] text-zinc-300 transition-all duration-500 group-hover:border-[var(--gold)]/40 group-hover:bg-[var(--gold)]/10 group-hover:text-[var(--gold-bright)]">
                  <ArrowUpRight className="h-4 w-4" strokeWidth={2} />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
